<template>
  <form
    ref="form"
    data-url="/technicalReviewer"
    :class="{ 'loading-opacity': preloader }"
  >
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Código Análisis</label>
          <app-input type="text" v-model="inputs.test" :disabled="true" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>Alcance General</label>
          <app-input type="textarea" v-model="inputs.test" :disabled="true" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>Valoración Global</label>
          <app-input
            type="textarea"
            v-model="inputs.global_valuation"
            placeholder="Ingrese la valoración global"
            :required="true"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
    };
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },
  created() {
    this.loadForm();
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(res) {
      this.$store.state.evaluatorReview.evalTest = res.data.data;
      console.log(res.data.data);
      this.$toastr.s(this.$t("updated_success"));
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    data() {},
    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest != null) {
        this.inputs = {
          id: this.$store.state.evaluatorReview.evalTestId,
          global_valuation: this.$store.state.evaluatorReview.evalTest
            .global_valuation,
        };
      }
    },
  },
};
</script>